import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ribbonStyle } from './styles';
function Ribbon({ size }) {
    return (_jsx("svg", Object.assign({ css: ribbonStyle({ size }), viewBox: "0 0 8 16", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M0 0h6.432a.833.833 0 0 1 .69 1.3L2.916 7.534a.833.833 0 0 0 0 .932L7.123 14.7a.833.833 0 0 1-.69 1.3H0V0Z", fill: "currentColor" }) })));
}
export default Ribbon;
